import { render, staticRenderFns } from "./InviteDropdown.vue?vue&type=template&id=4912a6ce"
import script from "./InviteDropdown.vue?vue&type=script&lang=js"
export * from "./InviteDropdown.vue?vue&type=script&lang=js"
import style0 from "./InviteDropdown.vue?vue&type=style&index=0&id=4912a6ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports